import script from "./TransactionConfirmDetailRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionConfirmDetailRow.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionConfirmDetailRow.vue?vue&type=style&index=0&id=181fc3cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181fc3cc"]])

export default __exports__